export default "__VITE_ASSET__BLUEU3IB__"